import React from "react";

/**
 * "GOOD EYES" official brand logo — sourced from Good Eyes Logos 4.pdf.
 * Uses two PNG variants (black on light bg, white on dark bg) with
 * transparent backgrounds. Aspect ratio: 1057 x 535.
 */
export const GoodEyesLogo = ({ className = "", height = 64, variant = "black" }) => {
  const src = variant === "white" ? "/assets/logo-white.png" : "/assets/logo.png";
  const width = height * (1057 / 535);
  return (
    <img
      src={src}
      alt="Good Eyes"
      className={className}
      style={{ height, width }}
    />
  );
};

export default GoodEyesLogo;
